// extracted by mini-css-extract-plugin
export default {"EmailRecovery":"EmailRecovery_EmailRecovery__TlR2y","imageContainer":"EmailRecovery_imageContainer__U0bbC"};